/** Snake renderer (C). Draws the grid, food and snake; no text. */
import {
    CELL, WIDTH, HEIGHT,
} from './snakeEngine';

export const COLORS = {
    background: '#020a04',
    grid: '#0a1c0f',
    body: '#32d74b',
    head: '#b7ff4a',
    eye: '#061006',
    food: '#ff453a',
    leaf: '#66d95c',
};

export function render(ctx, state) {
    ctx.fillStyle = COLORS.background;
    ctx.fillRect(0, 0, WIDTH, HEIGHT);

    ctx.fillStyle = COLORS.grid;
    for (let x = CELL; x < WIDTH; x += CELL) {
        ctx.fillRect(x, 0, 1, HEIGHT);
    }
    for (let y = CELL; y < HEIGHT; y += CELL) {
        ctx.fillRect(0, y, WIDTH, 1);
    }

    if (state.food) {
        ctx.fillStyle = COLORS.food;
        ctx.fillRect(state.food.x * CELL + 1, state.food.y * CELL + 2, CELL - 2, CELL - 3);
        ctx.fillStyle = COLORS.leaf;
        ctx.fillRect(state.food.x * CELL + 4, state.food.y * CELL, 3, 2);
    }

    for (let i = state.snake.length - 1; i >= 0; i -= 1) {
        const cell = state.snake[i];
        ctx.fillStyle = i === 0 ? COLORS.head : COLORS.body;
        ctx.fillRect(cell.x * CELL + 1, cell.y * CELL + 1, CELL - 2, CELL - 2);
    }

    const head = state.snake[0];
    const eyeOffsets = {
        up: [[2, 2], [5, 2]],
        down: [[2, 5], [5, 5]],
        left: [[2, 2], [2, 5]],
        right: [[5, 2], [5, 5]],
    };
    ctx.fillStyle = COLORS.eye;
    eyeOffsets[state.direction].forEach(([x, y]) => {
        ctx.fillRect(head.x * CELL + x, head.y * CELL + y, 1, 1);
    });
}
